/**
 * The TopNavBar component that lists the different routes available to users,
 * with a container to dock the sidebar alongside for our components
 */

import { chain, get, includes, isEmpty } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import locationProps from '../../Lib/Utils/PropTypes/location-props';
import { getApplicationStatus } from '../../Lib/Utils/FormUtils/vendor-application';
import ApplicationStatus from '../../Lib/Constants/vendor-application-status';
import UserRole from '../../Lib/Constants/roles.ts';
import VendorAgreementWall from '../VendorAgreementWall/VendorAgreementWall';
import { Navigation } from '../Navigation/Navigation.tsx';
import PrinterRequestsModal from '../ReusableComponents/PrinterRequests/PrinterRequestsModal.tsx';
import { ChatProvider } from '../Chat/index.ts';

class SideBar extends Component {
  constructor(props) {
    super(props);
    const {
      getUser,
      getVendor,
      getPublicFiles,
      location: { pathname },
    } = props;
    const userId = pathname.split('/')[2];

    getVendor(userId);
    getUser(userId);
    getPublicFiles('user');
  }

  render() {
    const {
      children,
      vendor,
      currentUser,
      logout,
      user,
      getVendor,
      publicFilesUrls,
      location: { pathname },
    } = this.props;

    const applicationStatus = getApplicationStatus(vendor);
    const approved = ApplicationStatus.APPROVED === applicationStatus;

    const isInfluencer = includes(
      [
        UserRole.INFLUENCER,
        UserRole.SOCIAL_MEDIA_MANAGER,
        UserRole.SOCIAL_MEDIA_OPS,
      ],
      get(user, 'role'),
    );
    const userId = pathname.split('/')[2];

    const isVendor = includes(
      [UserRole.VENDOR, UserRole.VENDOR_STAFF, UserRole.VENDOR_OPERATIONS],
      get(user, 'role'),
    );
    /**
     * Opens the user manual pdf in a new tab.
     */
    const openUserManual = () => {
      const influencerManualFileLink = get(
        publicFilesUrls,
        'influencer_vendor_portal_user_manual.read',
      );
      const VendorManualFileLink = get(publicFilesUrls, 'user_manual.read');

      const userManualURL = isInfluencer
        ? influencerManualFileLink
        : VendorManualFileLink;

      window.open(userManualURL);
    };

    const isComplianceOrAdmin = includes(
      [UserRole.ADMIN, UserRole.COMPLIANCE],
      get(currentUser, 'role'),
    );

    const unsignedDoc = chain(vendor)
      .get('vendor_documents')
      .filter((doc) => doc.name.toLowerCase().includes('agreement'))
      .sortBy('created_at')
      .first()
      .value();

    return (
      <ChatProvider userType="vp" userId={userId}>
        {unsignedDoc && user && !isComplianceOrAdmin && (
          <VendorAgreementWall
            user={user}
            document={unsignedDoc}
            logout={logout}
            getVendor={getVendor}
          />
        )}
        <Navigation
          currentUser={currentUser}
          user={user}
          applicationApproved={approved}
          logout={logout}
          openUserManual={openUserManual}
        >
          {!isEmpty(vendor) && !isEmpty(user) && children}
        </Navigation>
        {isVendor && <PrinterRequestsModal userId={userId} />}
      </ChatProvider>
    );
  }
}

SideBar.propTypes = {
  getUser: PropTypes.func.isRequired,
  vendor: PropTypes.shape({}).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  location: locationProps.isRequired,
  loading: PropTypes.bool.isRequired,
  currentUser: PropTypes.shape({}).isRequired,
  user: PropTypes.shape({}),
  logout: PropTypes.func.isRequired,
  getVendor: PropTypes.func.isRequired,
  publicFilesUrls: PropTypes.shape({}).isRequired,
  getPublicFiles: PropTypes.func.isRequired,
};

SideBar.defaultProps = {
  children: [],
  user: null,
};

export default SideBar;
